import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import * as moment from "moment"; // Needed For moment.preciseDiff() to work
import { PreciseDiff } from "../shared/precise-diff";

import { UserService } from "../../../shared/services/user.service";
import { DataService_viewlog } from "../viewlog/shared/data.service";

import { DataService_viewvisitordetail } from "./shared/data.service";

import { wsVPPAdminVisitorLogDetailInfo } from "./shared/wsVPPAdminVisitorLogDetailInfo";

//
// Needed For moment.preciseDiff() to work
//
// declare module "moment" {
// 	function preciseDiff(start: string | Date | moment.Moment, end: string | Date | moment.Moment, convertToObject?: boolean): any;
// }

@Component({
	selector: "VPP-ViewVisitorDetail",
	templateUrl: "./viewvisitordetail.component.html",
	styleUrls: ["./viewvisitordetail.component.css"],
})
export class ViewVisitorDetailComponent implements OnInit, OnDestroy {
	@Input() VisitorLogID: number = -1;

	subscription: Subscription;

	constructor(private dataService: DataService_viewvisitordetail, private userService: UserService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;

	public rVisitorLogDetail: wsVPPAdminVisitorLogDetailInfo;

	public Visitor_PersonID: number = -1;
	public VisitorLogStatusDesc: string = "";
	public FirstName: string = "";
	public LastName: string = "";
	public LogDT: Date = new Date();
	public CompanyName: string = "";
	public EntryFacilityLocation: string = "";
	public DestinationFacilityLocation: string = "";
	public RequiresEscort: boolean = false;
	public Barcode: string = "";
	public Primary_PresentedIDCardType: string = "";
	public Secondary_PresentedIDCardType: string = "";
	public DurationMin: number = 0;
	public strDurationMin: string = "";
	public isIn: boolean = false;
	public Comment: string = "";
	public Person_Image: string = "";
	public CapturedPhoto_Image: string = "";
	public CapturedSignature_Image: string = "";
	public Primary_PresentedIDCardScan_Image: string = "";
	public Secondary_PresentedIDCardScan_Image: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.dataService.onVisitorLogSelected().subscribe((response) => {
			this.VisitorLogID = response;

			if (this.VisitorLogID > 0) {
				this.isBusy = true;
				this.dataService.VPPAdminVisitorLogDetailGet(this.VisitorLogID).subscribe((data) => this.VPPAdminVisitorLogDetailGet_Complete(data));
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorLogDetailGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorLogDetailGet_Complete(data: any) {
		this.rVisitorLogDetail = data;

		var strDurationMinWork: string = "";

		if (this.rVisitorLogDetail.DurationMin < 1) {
			strDurationMinWork = "";
		} else {
			var intHour: number;
			var intMinute: number;
			var strHourz: string;
			var strMinutez: string;

			intHour = moment.duration(this.rVisitorLogDetail.DurationMin, "minutes").hours();
			intMinute = moment.duration(this.rVisitorLogDetail.DurationMin, "minutes").minutes();

			if (intHour == 1) {
				strHourz = " Hour";
			} else {
				strHourz = " Hours";
			}

			if (intMinute == 1) {
				strMinutez = " Minute";
			} else {
				strMinutez = " Minutes";
			}

			if (intHour == 0) {
				strDurationMinWork = intMinute.toString() + strMinutez;
			} else {
				strDurationMinWork = intHour.toString() + strHourz + " " + intMinute.toString() + strMinutez;
			}
		}

		this.Visitor_PersonID = this.rVisitorLogDetail.Visitor_PersonID;
		this.VisitorLogStatusDesc = this.rVisitorLogDetail.VisitorLogStatusDesc;
		this.FirstName = this.rVisitorLogDetail.FirstName;
		this.LastName = this.rVisitorLogDetail.LastName;
		this.LogDT = this.rVisitorLogDetail.LogDT;
		this.CompanyName = this.rVisitorLogDetail.CompanyName;
		this.EntryFacilityLocation = this.rVisitorLogDetail.EntryFacilityLocation;
		this.DestinationFacilityLocation = this.rVisitorLogDetail.DestinationFacilityLocation;
		this.RequiresEscort = this.rVisitorLogDetail.RequiresEscort;
		this.Barcode = this.rVisitorLogDetail.Barcode;
		this.Primary_PresentedIDCardType = this.rVisitorLogDetail.Primary_PresentedIDCardType;
		this.Secondary_PresentedIDCardType = this.rVisitorLogDetail.Secondary_PresentedIDCardType;
		this.DurationMin = this.rVisitorLogDetail.DurationMin;
		this.strDurationMin = strDurationMinWork;
		this.isIn = this.rVisitorLogDetail.isIn;
		this.Comment = this.rVisitorLogDetail.Comment;
		this.Person_Image = this.rVisitorLogDetail.Person_Image;
		this.CapturedPhoto_Image = this.rVisitorLogDetail.CapturedPhoto_Image;
		this.CapturedSignature_Image = this.rVisitorLogDetail.CapturedSignature_Image;
		this.Primary_PresentedIDCardScan_Image = this.rVisitorLogDetail.Primary_PresentedIDCardScan_Image;
		this.Secondary_PresentedIDCardScan_Image = this.rVisitorLogDetail.Secondary_PresentedIDCardScan_Image;

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
